<script>
  import StateDropdown from './stateDropdown.svelte'

  export let address = {
    first: '',
    last: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
  }
  export let onChange = null

  function inputOnChange() {
    if (onChange !== null) {
      onChange()
    }
  }
</script>

<style>
  .address-form {
    display: grid;
    grid-column-gap: var(--spacing-sm);
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-areas:
      'first last last'
      'address address address'
      'address2 address2 address2'
      'city state zip'
      'phone phone phone';
  }

  .form-first {
    grid-area: first;
  }
  .form-last {
    grid-area: last;
  }
  .form-address {
    grid-area: address;
  }
  .form-address2 {
    grid-area: address2;
  }
  .form-city {
    grid-area: city;
  }
  .form-state {
    grid-area: state;
  }
  .form-zip {
    grid-area: zip;
  }
  .form-phone {
    grid-area: phone;
  }
</style>

<form class="address-form">

  <div class="form-field form-first">
    <label for="first-name" class="form-field-label">First Name</label>
    <input
      id="first-name"
      class="form-input"
      bind:value={address.first}
      on:change={() => inputOnChange()}
      required />
  </div>

  <div class="form-field form-last">
    <label for="last-name" class="form-field-label">Last Name</label>
    <input
      id="last-name"
      class="form-input"
      bind:value={address.last}
      on:change={() => inputOnChange()}
      required />
  </div>

  <div class="form-field form-address">
    <label for="address1" class="form-field-label">Address</label>
    <input
      id="address1"
      class="form-input"
      bind:value={address.address}
      on:change={() => inputOnChange()}
      required />
  </div>

  <div class="form-field form-address2">
    <label for="address2" class="form-field-label">Address 2 (Optional)</label>
    <input
      id="address2"
      class="form-input"
      bind:value={address.address2}
      on:change={() => inputOnChange()} />
  </div>

  <div class="form-field form-city">
    <label for="address-city" class="form-field-label">City</label>
    <input
      id="address-city"
      class="form-input"
      bind:value={address.city}
      on:change={() => inputOnChange()}
      required />
  </div>

  <div class="form-field form-state">
    <label for="address-state" class="form-field-label">State</label>
    <StateDropdown
      id="address-state"
      required
      bind:state={address.state}
      on:change={() => inputOnChange()} />
  </div>

  <div class="form-field form-zip">
    <label for="address-zip" class="form-field-label">Zip Code</label>
    <input
      id="address-zip"
      class="form-input"
      bind:value={address.zip}
      on:change={() => inputOnChange()}
      inputmode="numeric"
      pattern={String.raw`\d{5}([-\s]\d{4})?`}
      title="12345 or 12345-6789" />
  </div>
  <div class="form-field form-phone">
    <label for="address-phone" class="form-field-label">Phone</label>
    <input
      id="address-phone"
      class="form-input"
      bind:value={address.phone}
      on:change={() => inputOnChange()}
      required />
  </div>
</form>
